import ProfilePhoto from "./ProfilePhoto";
import ProfileList from "./ProfileList";
import Grid from "@mui/material/Grid";

function Profile(props) {
    return (
        <Grid container direction="column" justifyContent="center" alignItems="center">
            <ProfilePhoto photo={props.photo} alt={props.name} size="large" />
            <ProfileList name={props.name} />
        </Grid>
    );
}

export default Profile;
